import { Flex } from 'antd';
import classNames from 'classnames';
import { useState, MouseEvent } from 'react';
import { Outlet } from 'react-router';

import { MobileSideMenu, Footer, HeaderWrapper } from '@/widgets/Layout';

import { FloatActionButtons } from '@/features/ui';

import AccessibilityContext from '@/contexts/AccessibilityContext';

import css from './MainTemplate.module.scss';
import '@/containers/StyleSettings/themes/default/layout.scss';

export const MainTemplate: React.FC = () => {
  const [isPanelShown, setPanelViewState] = useState<boolean>(false);

  const toggleAccessibilityPanel = (): void => {
    setPanelViewState((prev) => {
      const newState = !prev;
      return newState;
    });
  };

  const turnOnAccessibilityPanel = (event: MouseEvent<HTMLElement>): void => {
    event.preventDefault();
    toggleAccessibilityPanel();
  };

  return (
    <AccessibilityContext.Provider value={{ isPanelShown, turnOnAccessibilityPanel }}>
      <Flex vertical id="main-template">
        <HeaderWrapper isPanelShown={isPanelShown} />
        <MobileSideMenu />
        <main className={classNames('main', css.main)} id="main">
          <Outlet />
        </main>
        <Footer />
        <FloatActionButtons />
      </Flex>
    </AccessibilityContext.Provider>
  );
};
